import "@/App.css";
import SmoothScroll from "@/components/site/SmoothScroll";
import { LanguageProvider } from "@/i18n";
import { Preloader } from "@/components/site/Preloader";
import { CustomCursor } from "@/components/site/CustomCursor";
import { LanguageTransition } from "@/components/site/LanguageTransition";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { References } from "@/components/site/References";
import { Marquee } from "@/components/site/Marquee";
import { LocationMap } from "@/components/site/LocationMap";
import { Contact } from "@/components/site/Contact";

function App() {
  return (
    <LanguageProvider>
      <Preloader />
      <CustomCursor />
      <LanguageTransition />
      <SmoothScroll>
        <div className="App grain relative bg-[var(--bg-0)] text-[var(--txt)]">
          <Header />
          <main>
            <Hero />
            <About />
            <Services />
            <References />
            <Marquee />
            <LocationMap />
            <Contact />
          </main>
          <WhatsAppFab />
        </div>
      </SmoothScroll>
    </LanguageProvider>
  );
}

export default App;
